if (!customElements.get('ymp-shipping-countdown')) {
  class YmpShippingCountdown extends HTMLElement {
    connectedCallback() {
      this._label = this.dataset.countdownLabel || '';
      this._cutoffHour = Number(this.dataset.cutoffHour) || 14;
      this._hoursLabel = this.dataset.hoursLabel || 'h';
      this._minutesLabel = this.dataset.minutesLabel || 'm';
      this._textEl = this.querySelector('[data-ymp-shipping-countdown-text]');
      if (!this._textEl) return;

      this._update();
      this._timer = window.setInterval(() => this._update(), 30000);
    }

    disconnectedCallback() {
      if (this._timer) window.clearInterval(this._timer);
    }

    _update() {
      const wasHidden = this.hidden;
      const now = new Date();
      const cutoff = new Date();
      cutoff.setHours(this._cutoffHour, 0, 0, 0);

      if (now >= cutoff) {
        if (!wasHidden) {
          this.dispatchEvent(new CustomEvent('ymp-shipping-cutoff-passed', { bubbles: true }));
        }
        this.hidden = true;
        return;
      }

      this.hidden = false;
      const diffMs = cutoff - now;
      const hours = Math.floor(diffMs / 3600000);
      const minutes = Math.floor((diffMs % 3600000) / 60000);
      this._textEl.innerHTML = `${this._label} <span class="ymp-shipping__countdown-time">${hours}${this._hoursLabel} ${minutes}${this._minutesLabel}</span>`;
    }
  }

  customElements.define('ymp-shipping-countdown', YmpShippingCountdown);
}

if (!customElements.get('ymp-shipping-date')) {
  class YmpShippingDate extends HTMLElement {
    connectedCallback() {
      this._deliveryDays = Number(this.dataset.deliveryDays) || 3;
      this._cutoffHour = Number(this.dataset.cutoffHour) || 14;
      this._addDayAfterCutoff = this.dataset.addDayAfterCutoff === 'true';
      this._countdownEnabled = this.dataset.countdownEnabled === 'true';
      this._locale = this._resolveLocale(this.dataset.locale);

      this._onCutoffPassed = () => this._update();
      this.closest('.ymp-shipping')?.addEventListener('ymp-shipping-cutoff-passed', this._onCutoffPassed);

      this._update();
      this._timer = window.setInterval(() => this._update(), 30000);
    }

    disconnectedCallback() {
      this.closest('.ymp-shipping')?.removeEventListener('ymp-shipping-cutoff-passed', this._onCutoffPassed);
      if (this._timer) window.clearInterval(this._timer);
    }

    _resolveLocale(locale) {
      const raw = (locale || document.documentElement.lang || '').trim().replace(/_/g, '-');
      if (!raw) return undefined;

      try {
        const supported = Intl.DateTimeFormat.supportedLocalesOf([raw]);
        return supported[0] || undefined;
      } catch (error) {
        return undefined;
      }
    }

    _isPastCutoff() {
      const now = new Date();
      const cutoff = new Date();
      cutoff.setHours(this._cutoffHour, 0, 0, 0);
      return now >= cutoff;
    }

    _isEnglishLocale() {
      const lang = String(this._locale || document.documentElement.lang || 'en')
        .toLowerCase()
        .split('-')[0];
      return lang === 'en';
    }

    _formatDate(extraDays = 0) {
      const date = new Date();
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() + this._deliveryDays + extraDays);

      const parts = new Intl.DateTimeFormat(this._locale, {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      }).formatToParts(date);

      const getPart = (type) => parts.find((part) => part.type === type)?.value || '';
      const month = getPart('month');
      const day = getPart('day');
      const year = getPart('year');

      // English: August 5, 2026
      if (this._isEnglishLocale()) {
        const monthLabel = month ? month.charAt(0).toLocaleUpperCase(this._locale) + month.slice(1) : '';
        return `${monthLabel} ${day}, ${year}`.trim();
      }

      // Dutch and other locales: 5 augustus 2026
      return `${day} ${month} ${year}`.trim();
    }

    _update() {
      let extraDays = 0;
      if (this._countdownEnabled && this._addDayAfterCutoff && this._isPastCutoff()) {
        extraDays = 1;
      }
      this.textContent = this._formatDate(extraDays);
    }
  }

  customElements.define('ymp-shipping-date', YmpShippingDate);
}
